<template>
  <material-card
    :title="title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs6
            md3>
            <v-text-field
              v-model.trim="newGroup.groupDescription"
              :rules="rules.required.concat(rules.maxLen_30)"
              :counter="30"
              :label="`${ $t('Name') }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs6
            md2>
            <v-select
              v-show="options !== undefined && options.productTypes !== undefined"
              v-model="newGroup.productFamily"
              :items="productTypeList"
              :label="`${ $t('Product family') }`"
              item-text="desc"
              item-value="code"
              class="dover-input"
              chips
              @change="onProductTypeChange()">
              <template
                slot="selection"
                slot-scope="data">
                <v-chip
                  :selected="data.selected"
                  :disabled="data.disabled"
                  :key="data.item.code"
                  class="v-chip--select-multi "
                  @input="data.parent.selectItem(data.item)">
                  <v-avatar class="dover-avatar ">{{ data.item.code }}</v-avatar>
                  {{ data.item.desc }}
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex
            xs12
            md5
            lg5>
            <span
              class="caption grey--text font-weight-bold">
              {{ $t('Available tanks') }}
            </span>
            <br>
            <v-btn-toggle
              v-model="newGroup.connectedTanks"
              multiple>
              <v-btn
                v-for="(item, index) in tankProductTypeMapping[newGroup.productFamily]"
                :key="index"
                :value="item"
                text
                small
                color="dover-blue">
                {{ getButtonDescription(item) }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex
            xs12
            md1
            lg1
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onSaveNew()">
              {{ $t('Save new') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <hr>
          </v-flex>
          <MaglinkComponentDialogYesNo
            :key="dialogYN.key"
            :component-key="dialogYN.componentKey"
            :dialog="dialogYN.show"
            :title="dialogYN.title"
            :label-text="dialogYN.labelText"
            :custom-par1="dialogYN.action"
            :custom-par2="dialogYN.result"
            @dialogResultYesNo="dialogResult"/>
          <v-flex
            id="printTankGroups"
            xs12
            md12
            lg12>
            <v-data-table
              v-if="newTankGroups"
              :headers="headers"
              :items="newTankGroups"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text"/>
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }"
                class="dover-light-blue-color">
                <td
                  class="text-xs-right"
                  width="5%">
                  {{ item.groupNumber }}
                </td>
                <td
                  class="text-xs-left"
                  width="25%">
                  <v-text-field
                    v-model.trim="item.groupDescription"
                    :rules="rules.required.concat(rules.maxLen_30)"
                    :counter="30"
                    :label="`${ $t('Name') }`"
                    class="dover-input"/>
                </td>
                <td
                  class="text-xs-left"
                  width="15%">
                  {{ $t(item.productFamilyDesc) }}
                </td>
                <td
                  class="text-xs-left">
                  <v-btn-toggle
                    v-model="item.connectedTanks"
                    mandatory
                    multiple>
                    <v-btn
                      v-for="(btn, index) in tankProductTypeMapping[item.productFamily]"
                      :key="index"
                      :value="btn"
                      text
                      small
                      color="dover-blue">
                      {{ getButtonDescription(btn) }}
                    </v-btn>
                  </v-btn-toggle>
                </td>
                <td
                  class="text-xs-right"
                  width="10%">
                  <v-icon
                    :disabled="!isValidationOk"
                    small
                    class="mr-2"
                    @click="onSave(item, index)">
                    mdi-content-save-all
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2"
                    @click="onDelete(item, index)">
                    mdi-delete-forever
                  </v-icon>
                </td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12
            text-xs-right>
            <v-btn
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onPrintForm">
              {{ $t('Print') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import { i18n } from '@/i18n'
import Vue from 'vue'
import print from 'print-js'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValidationOk: false,
    tankGroups: undefined,
    newTankGroups: [],
    availableTanks: [],
    siteInfo: {},
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      maxLen_30: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 30) ]
    },
    tanks: [],
    options: {},
    productTypeList: [],
    tankOfProductType: [1, 2, 5],
    tankProductTypeMapping: [],
    newGroup: {
      groupDescription: '',
      groupNumber: 0,
      productFamilyDesc: '',
      productFamily: 0,
      connectedTanks: []
    },
    headers: [
      { sortable: false, text: i18n.t('Number') },
      { sortable: false, text: i18n.t('Name') },
      { sortable: false, text: i18n.t('Product family') },
      { sortable: false, text: i18n.t('Tank list') },
      { sortable: false, text: '' }
    ],
    dialogYN: {
      key: 0,
      show: false,
      componentKey: '',
      title: '',
      labelText: '',
      action: '',
      result: ''
    }
  }),
  mounted () {
    this.Maglink.GetOptions()
      .then(response => {
        this.Maglink.TranslateOptionNames(response)
        this.options = { ...this.options, ...response.data }
        this.productTypeList = this.options.productTypes.sort((a, b) => (a.desc > b.desc) ? 1 : -1)

        // read tank data and prepare mapping
        this.getTank()
        this.getTankGroups()
      })
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    onProductTypeChange () {
      // to force initial selection of all tanks
      this.newGroup.connectedTanks = this.tankProductTypeMapping[this.newGroup.productFamily]
    },
    onSaveNew () {
      if (!this.$refs.form.validate()) {
        this.isValidationOk = false
        return
      }
      // check minimun number of tanks selected
      if (!this.canSave(this.newGroup)) return

      this.isValidationOk = true

      // set data for new item to add to collection of group tanks
      let group = {
        groupNumber: 0,
        groupDescription: this.newGroup.groupDescription,
        connectedTanks: this.newGroup.connectedTanks,
        productFamily: this.newGroup.productFamily,
        productFamilyDesc: ''
      }

      this.newTankGroups.push(group)
      this.saveTankGroup(group)
    },
    onSave (group, index) {
      // check minimun number of tanks selected
      if (!this.canSave(group)) return

      this.saveTankGroup(group)
    },
    onDelete (group, index) {
      this.dialogYN.title = this.$t('Warning').toUpperCase()
      this.dialogYN.labelText = '\n\n' + this.$t('You are about to DELETE selected tank group: {0}', [ group.groupDescription ]) + '\n\n' + this.$t('Are you sure?')
      this.dialogYN.componentKey = 'delete'
      this.dialogYN.action = 'delete'
      this.dialogYN.result = group.groupNumber.toString()
      this.dialogYN.show = true
    },
    canSave (group) {
      if (group.connectedTanks.length < 2) {
        this.snack('error', this.$t('Select at least 2 tanks'))
        return false
      }

      return true
    },
    saveTankGroup (group) {
      this.Maglink.SaveTankGroup(group)
        .then(response => {
          this.snack('success', this.$t('Saved successfully'))
          this.getTankGroups()
        })
        .catch(error => (this.snack('error', error.message)))

      this.$emit('settingsSaved')
    },
    dialogResult (componentKey, result, action, par2) {
      this.dialogYN.show = false

      // NO button pressed
      if (!result) return

      let id = par2 * 1
      this.Maglink.DeleteTankGroup(id)
        .then(response => {
          this.snack('success', this.$t('Deleted successfully'))
          this.getTankGroups()
        })
        .catch(error => (this.snack('error', error.message)))

      this.$emit('settingsSaved')
    },
    getTankGroups () {
      this.Maglink.GetTanksGroups()
        .then(response => {
          this.tankGroups = response.data
          this.newTankGroups = []
          this.tankGroups.forEach(group => {
            let newGroup = {
              groupNumber: group.groupNumber,
              groupDescription: group.groupDescription,
              connectedTanks: group.connectedTanks,
              productFamilyDesc: group.productType,
              productFamily: group.productFamily
            }
            /*
            for (let index = 0; index < group.connectedTanks.length; index++) {
              newGroup.connectedTanks.push(group.connectedTanks[index])
            }
            */
            this.newTankGroups.push(newGroup)
          })
        })
        .catch(error => (this.snack('error', error.message)))
    },
    getTank () {
      this.tankProductTypeMapping = []

      // creating initial array used for mapping
      for (let i = 0; i < this.options.productTypes.length; i++) {
        this.tankProductTypeMapping.splice(i, 0, [])
      }

      // group tanks based upon product type
      this.Maglink.GetTanks()
        .then(response => {
          this.tanks = response.data

          this.tanks.forEach(tank => {
            this.tankProductTypeMapping[tank.productFamily].push(tank.tankNumber)
          })
          this.onProductTypeChange() // to force initial selection of all tanks
        })
        .catch(error => (this.snack('error', error.message)))
    },
    getButtonDescription (item) {
      return item + ' - ' + this.tanks[item - 1].tankDescription
    },
    onPrintForm () {
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      let name = this.title
      print({
        printable: 'printTankGroups',
        type: 'html',
        header: name,
        headerStyle: 'font-weight: 100;',
        scanStyles: false,
        css: stylesHtml
      })
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
